import { createAppAsyncThunk } from 'src/store/utils/thunks';
import { resetStore } from 'src/store/actions';
import { clearAccessToken } from '@skynet/data-auth-api';
import { preferencesActions } from '@skynet/data-preferences';
import { signupActions } from '@skynet/data-signup';
import { clearCerbosCheckCache } from '@skynet/authz-core';

/**
 * Dashboard-specific sign-out thunk.
 * Purges persisted state and resets the store before clearing signup state.
 *
 * Cerbos decisions live outside Redux (see `clearCerbosCheckCache`) and are
 * keyed by principal, so a different user can never read them — but the same
 * user signing back in would, and their permissions may have been changed
 * server-side in between. Drop them here so the next session re-asks the PDP.
 *
 * Preferences are user-level, so they stay out of `resetStore`, which a tenant
 * switch dispatches too, and are cleared here instead.
 */
export const signOut = createAppAsyncThunk('auth/signOut', async (_, thunkApi) => {
  if (thunkApi.extra.persistor) {
    await thunkApi.extra.persistor.purge();
    await thunkApi.extra.persistor.flush();
  }

  thunkApi.dispatch(resetStore());
  thunkApi.dispatch(preferencesActions.resetPreferences());
  // resetAllRtkApiStates(thunkApi.dispatch);
  thunkApi.dispatch(clearAccessToken());
  thunkApi.dispatch(signupActions.resetSignupState());
  clearCerbosCheckCache();
});
